import { RegisterOptions, UseFormReturn } from "react-hook-form";
import { getValueByString } from "../Utils";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { useGlobalData } from "../../GlobalDataProvider";
import { useEffect, useRef } from "react";

interface IProps {
  label: string;
  fieldName: string;
  formHook: UseFormReturn;
  options?: RegisterOptions;
  children?: React.ReactNode;
  multiline?: boolean;
  rows?: number;
  tooltipId?: string;
  isDisabled?: boolean;
  showWhenIsDisabled?: boolean;
  isPassword?: boolean;
}

const TextEditor = ({ label, fieldName, formHook, options, multiline, children, rows, tooltipId, isDisabled, showWhenIsDisabled, isPassword }: IProps) => {
  const { register, formState, setValue } = formHook;
  const globalData = useGlobalData();
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const maxHeight = 200; // Set a maximum height for the textarea
  useEffect(() => {
    if (textareaRef.current) {
      (textareaRef.current as any).style.height = "auto";
      (textareaRef.current as any).style.height = `${Math.min((textareaRef.current as any).scrollHeight, maxHeight)}px`;
    }
  }, []);

  const errors = formState.errors;
  const isInValid: any = getValueByString(errors, fieldName); //errors[fieldName];

  const renderTooltip = (props: any) => {
    if (isInValid)
      return (
        <Tooltip {...props} className="validationErrorTooltip">
          <span>{isInValid.message}</span>
        </Tooltip>
      );
    if (tooltipId && globalData.data?.Tooltip.mapTooltip[tooltipId])
      return (
        <Tooltip {...props} className="defaultTooltip">
          <span style={{ whiteSpace: "pre-line" }}>{globalData.data?.Tooltip.mapTooltip[tooltipId]}</span>
        </Tooltip>
      );
    else return <></>;
  };

  const type = isPassword ? "password" : "text";

  const getTextEditor = () => {
    var htmlPart;

    //Actual input area
    if (isDisabled) {
      if (showWhenIsDisabled) htmlPart = <input id={label} type={type} disabled={isDisabled} {...register(fieldName, options)} className={"form-control " + (isInValid ? "is-invalid" : "")} />;
      else htmlPart = <input value={""} type={type} disabled={isDisabled} className={"form-control "} />;
    } else {
      if (multiline) {
        const registerProps = register(fieldName, options);
        const { onChange, ref } = registerProps;
        delete (registerProps as any).onChange; // Remove onChange from registerProps to avoid double call
        delete (registerProps as any).ref; // Remove ref from registerProps to avoid double call
        const handleTextAreaChange = (event: any) => {
          const { value } = event.target;
          setValue(fieldName, value, { shouldValidate: true });
          if (textareaRef.current) {
            (textareaRef.current as any).style.height = "auto";
            (textareaRef.current as any).style.height = `${Math.min((textareaRef.current as any).scrollHeight, maxHeight)}px`;
          }
          onChange(event); // Call RHF's onChange
        };
        //rows={rows}
        htmlPart = (
          <OverlayTrigger placement="top" overlay={renderTooltip}>
            <textarea
              id={label}
              disabled={isDisabled}
              {...registerProps}
              ref={(e) => {
                textareaRef.current = e;
                ref(e); // Forward ref to RHF
              }}
              onChange={handleTextAreaChange}
              className={"form-control " + (isInValid ? "is-invalid" : "")}
              rows={rows}
              style={{ resize: "none", overflowY: "scroll" }} // Prevent resizing handle
            />
          </OverlayTrigger>
        );
      } else {
        htmlPart = (
          <OverlayTrigger placement="top" overlay={renderTooltip}>
            <input id={label} type={type} disabled={isDisabled} {...register(fieldName, options)} className={"form-control " + (isInValid ? "is-invalid" : "")} />
          </OverlayTrigger>
        );
      }
    }

    //Input group wrapper and validation
    htmlPart = (
      <div className={(children ? "input-group" : "") + " w-100"}>
        {htmlPart}
        {children}
        {/* {isInValid?.message && <div className="invalid-feedback">{isInValid?.message?.toString()}</div>} */}
      </div>
    );

    //Label if exists
    if (label) {
      htmlPart = (
        <label className="form-label w-100">
          {label}
          {htmlPart}
        </label>
      );
    }

    htmlPart = <div className="input-group has-validation">{htmlPart}</div>;

    return htmlPart;
  };

  return <>{getTextEditor()}</>;
};

export default TextEditor;
